import React, { useState } from 'react';

const Rules = () => {
    return (
        <div className="container py-5 my-5">
            <h2>Pravidla sítě echo</h2>
            <ul class="list-group list-group-flush">
                <li className="main-text list-group-item bg-transparent lead">Citlivé příspěvky znázorňující krev,
                    bolest, nenávist,
                    diskriminaci, týrání zvířat, či jiné mohou být <span
                        className="text-danger">skryty, či smazány</span>. Tyto obrázky může smazat automaticky portál Imgur!
                </li>
                <li className="main-text list-group-item bg-transparent lead">Zákaz spamu za účelem získání Tokenů
                    -> <span
                        className="text-danger">Smazání příspěvků a možné zablokování postavy na echo.</span></li>
                <li className="main-text list-group-item bg-transparent lead">Zákaz vydávání se za jinou osobu -> <span
                    className="text-danger">Zablokování postavy na echo.</span></li>
            </ul>
        </div>
    )
        ;
};

export default Rules;
